import { ITranslate } from "@/interfaces/ITranslate";

export const WorksheetHasVehiclesTranslate: ITranslate = {
  km: "los kilómetros recorridos",
  driverId: "al conductor",
};
